export const env = {
    type: process.env.VUE_APP_TYPE,
    name: process.env.VUE_APP_NAME,
    company: process.env.VUE_APP_COMPANY,
    language: process.env.VUE_APP_DEFAULT_LANGUAGE,
    basePath: process.env.VUE_APP_BASE_PATH,
    apiUrl: process.env.VUE_APP_API_URL,
};

// filepath: d:\Developing\Web\Proyectos\MyOwn\Crocodeline\Filologia\Valesco\valesco_frontend\src\plugins\utilityMixins.js
const EnvironmentMixins = {
    install(Vue) {
        Vue.mixin({
            computed: {
                $env() {
                    return env;
                }
            }
        });
    }
};

export default EnvironmentMixins;